import PropTypes from 'prop-types';

import Stack from '@mui/material/Stack';

const AuthPage = ({ ErrorRP, children }) => (
	<Stack sx={{ padding: '32px', minHeight: '100vh', width: '100%' }}>
		{children || (ErrorRP && <ErrorRP />)}
	</Stack>
);

AuthPage.propTypes = {
	ErrorRP: PropTypes.elementType,
	children: PropTypes.node,
};

export default AuthPage;
